// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__257rO","header":"MessagesList_header__1vt-T","chat":"MessagesList_chat__11GWR"};